function readStringProp(value: object, key: string): string {
  const record = value as Record<string, unknown>;
  return typeof record[key] === "string" ? (record[key] as string) : "";
}

function readNumberProp(value: object, key: string): number {
  const record = value as Record<string, unknown>;
  return typeof record[key] === "number" ? (record[key] as number) : Number(record[key]);
}

export function serializeDarFormDraftValues(
  values: Record<string, unknown>,
): Record<string, unknown> {
  const darDate = values.dar_date;
  const files = Array.isArray(values.files)
    ? values.files.filter((file): file is string => typeof file === "string")
    : [];

  const property = values.property;
  const slimProperty =
    property && typeof property === "object" && "id" in property
      ? {
          id: readNumberProp(property, "id"),
          name: readStringProp(property, "name"),
        }
      : property;

  const darType = values.dar_type;
  const slimDarType =
    darType && typeof darType === "object" && "daily_activity_report_type_id" in darType
      ? {
          daily_activity_report_type_id: readNumberProp(darType, "daily_activity_report_type_id"),
          type: readStringProp(darType, "type") || readStringProp(darType, "name"),
        }
      : darType;

  const darCode = values.dar_code;
  const slimDarCode =
    darCode && typeof darCode === "object" && "daily_activity_report_code_id" in darCode
      ? {
          daily_activity_report_code_id: readNumberProp(darCode, "daily_activity_report_code_id"),
          type: readStringProp(darCode, "type") || readStringProp(darCode, "name"),
          code: readStringProp(darCode, "code"),
        }
      : darCode;

  return {
    details: values.details ?? "",
    dar_date:
      darDate instanceof Date ? darDate.toISOString() : typeof darDate === "string" ? darDate : null,
    dar_time: values.dar_time ?? null,
    files,
    property: slimProperty,
    dar_type: slimDarType,
    dar_code: slimDarCode,
    include_gps_coordinates: values.include_gps_coordinates ?? false,
    send_notification: values.send_notification ?? false,
  };
}

export function deserializeDarFormDraftValues(
  values: Record<string, unknown>,
): Record<string, unknown> {
  const darDate = values.dar_date;

  return {
    ...values,
    dar_date:
      typeof darDate === "string"
        ? new Date(darDate)
        : darDate instanceof Date
          ? darDate
          : new Date(),
    files: Array.isArray(values.files) ? values.files : [],
  };
}

export function getDarFormDraftKey(
  isEditing: boolean,
  darId?: number | null,
  contextPropertyId?: number | null,
) {
  if (isEditing && darId != null) {
    return `dar:edit:${darId}`;
  }
  if (contextPropertyId != null) {
    return `dar:create:${contextPropertyId}`;
  }
  return "dar:create";
}
